import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Rocket } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

export const CTASection = () => {
  const { t, language } = useLanguage();

  return (
    <section className="py-24 section-gradient-dark relative overflow-hidden">
      {/* Decorative */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-accent/10 rounded-full blur-3xl pointer-events-none" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-white/10 border border-white/20 mb-6">
          <Rocket className="w-4 h-4 text-gaius-glow mr-2" />
          <span className="text-sm font-medium text-white/80">
            {language === 'fr' ? 'Rejoignez 500+ professionnels formés' : 'Join 500+ trained professionals'}
          </span>
        </div>

        <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
          {language === 'fr' ?
          'Prêt à maîtriser l\'IA juridique ?' :
          'Ready to Master Legal AI?'
          }
        </h2>
        <p className="text-xl text-white/70 mb-8 max-w-2xl mx-auto">
          {language === 'fr' ?
          'Rejoignez des centaines de professionnels du droit qui transforment leur pratique avec l\'intelligence artificielle.' :
          'Join hundreds of legal professionals transforming their practice with artificial intelligence.'
          }
        </p>
        <div className="flex flex-col items-center gap-4">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg" className="text-lg px-8 py-3 bg-white text-foreground hover:bg-white/90 glow-primary">
              <Link to="/training" className="flex items-center space-x-2">
                <span>{language === 'fr' ? 'Voir nos formations' : 'View Our Training'}</span>
                <ArrowRight className="w-5 h-5" />
              </Link>
            </Button>
            <Button asChild size="lg" className="text-lg px-8 py-3 gradient-bg text-white hover:opacity-90 glow-accent">
              <Link to="/formations-eligibles-financements" className="flex items-center space-x-2">
                <span>{language === 'fr' ? 'Découvrir les formations IA Juridique' : 'Discover Legal AI Training'}</span>
                <ArrowRight className="w-5 h-5" />
              </Link>
            </Button>
          </div>
          <Button asChild variant="link" className="text-white/80 hover:text-white underline underline-offset-4 text-base">
            <Link to="/training/eligible">
              {language === 'fr'
                ? 'Découvrir les formations éligibles OPCO · FIF-PL · CPF'
                : 'Discover funded training programs (OPCO · FIF-PL · CPF)'}
            </Link>
          </Button>
        </div>
      </div>
    </section>);
};
